import { render, staticRenderFns } from "./BPJSCorrectionData.vue?vue&type=template&id=0d6bee15&scoped=true"
import script from "./BPJSCorrectionData.vue?vue&type=script&lang=js"
export * from "./BPJSCorrectionData.vue?vue&type=script&lang=js"
import style0 from "./BPJSCorrectionData.vue?vue&type=style&index=0&id=0d6bee15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6bee15",
  null
  
)

export default component.exports